<ng-template #productsDrawerTemplate>
  <div>
    <nz-spin [nzSpinning]="isLoading">

    <app-products-table
      [products]="modalRecords"
      [payload]="productsPayload"
      [isLoading]="isLoading"
      [totalCount]="totalProductsCount"
      [selectable]="true"
      [listColumns]="listColumns"
      [savedFilters]="savedFilters"
      [setOfSelectedProducts]="tempSelectedProducts"
      (selectionChange)="onProductSelectionChange($event)"
      (getProducts)="productsPayload = $event;handleGetProducts($event)"
      (headerFiltersChanged)="handleFiltersChanges($event)"
    ></app-products-table>
   
  </nz-spin>
  </div>

  
</ng-template>

<ng-template #recordsDrawerFooter>
  <nz-space>
    <button nz-button nzType="primary" (click)="selectRows()">Submit</button>
    <button nz-button (click)="cancelSelection()">Cancel</button>
  </nz-space>
</ng-template>
